//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// suggestion-action-view-meeting imports
import { IContainer, IProps } from "./SuggestionActionViewMeeting.d";
import { fragments } from "./SuggestionActionViewMeeting.gql";
import { CardButton } from "@components/card";
// util
import { logger } from "@util/logger.util";
// state
import { setActiveViewEvent } from "@actions/chrome-extension.actions";
import { IReduxState } from "@reducers/root.reducer";
// material-ui
import { ArrowForward } from "@material-ui/icons";

//////////////////
// COMPONENT
//////////////////
class SuggestionActionViewMeetingCmpt extends React.Component<IProps> {
  private viewMeeting = () => {
    const { actionCallback, payload } = this.props;
    const { externalEventId, calendarId } = payload;

    if (actionCallback) {
      logger.debug("Setting ActiveViewEvent from SuggestionActionViewMeetingCmpt", {
        externalEventId,
        calendarId,
      });

      this.props.setActiveViewEvent(externalEventId, calendarId, false);

      actionCallback();
    }
  };

  public render() {
    const { label } = this.props;
    return <CardButton flat icon={<ArrowForward />} onClick={this.viewMeeting} label={label} />;
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const SuggestionActionViewMeetingRedux = connect(mapStateToProps, {
  setActiveViewEvent,
})(SuggestionActionViewMeetingCmpt);

//////////////////
// RELAY
//////////////////
export const SuggestionActionViewMeeting = createFragmentContainer<IContainer>(
  SuggestionActionViewMeetingRedux,
  fragments,
);
